export default (params) => ({
  trigger: {
    name: 'recommended_accessories.select_upsell_alternative',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'upsell_collection',
        method: null,
      },
    },
  },
});
